import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import DeviceMockupsWithSolutions from "@/components/DeviceMockupsWithSolutions";
import ProcessSection from "@/components/ProcessSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ServicesSection />
      <DeviceMockupsWithSolutions />
      <ProcessSection />
      <CTASection />
      <Footer />
    </div>
  );
}
